"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toUpper = void 0;
const to_string_1 = require("./to-string");
exports.toUpper = (value) => to_string_1.toString(value).toUpperCase();
//# sourceMappingURL=to-upper.js.map